import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Column } from '../../layout';
import { BaseInput } from './base_input';
import Label from '../../typography/label';
import styled from '../../../styles/styled';
import { focus } from '../../../styles/theme';
const Container = styled.div({
    width: '100%',
    ':focus-within': focus.shadow,
});
export const BasicInput = ({ name, hideLabel, height, ...rest }) => {
    return (_jsxs(Column, { flex: "1", alignItems: "flex-start", children: [_jsx(Label, { bold: true, capitalize: true, htmlFor: name, screenReaderOnly: hideLabel, children: name }), _jsx(Container, { children: _jsx(BaseInput, { id: name, name: name, height: height, ...rest }) })] }));
};
//# sourceMappingURL=basic_input.js.map